import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { VivaInputComponent } from './viva-input.component';

@NgModule({
  declarations: [
    VivaInputComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    VivaInputComponent
  ]
})
export class  VivaInputModule { }
